(function () {
  var STORAGE_KEY = 'dm:favorites';
  var grid = document.querySelector('[data-favorites-grid]');
  var emptyState = document.querySelector('[data-favorites-empty]');

  if (!grid || !emptyState) {
    return;
  }

  function readFavorites() {
    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      var parsed = stored ? JSON.parse(stored) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeFavorites(favorites) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
      window.dispatchEvent(
        new CustomEvent('dm:favorites:change', {
          detail: {
            favorites: favorites,
          },
        })
      );
    } catch (error) {
      return false;
    }

    return true;
  }

  function createImage(product) {
    var link = document.createElement('a');
    link.className = 'favorites-card__image-link';
    link.href = product.url || '#';
    link.setAttribute('aria-label', product.title || 'Ver producto');

    if (product.image) {
      var image = document.createElement('img');
      image.src = product.image;
      image.alt = product.title || '';
      image.loading = 'lazy';
      link.appendChild(image);
      return link;
    }

    var placeholder = document.createElement('div');
    placeholder.className = 'favorites-card__placeholder';
    placeholder.textContent = 'Diseños en Madera';
    link.appendChild(placeholder);
    return link;
  }

  function createCard(product) {
    var card = document.createElement('article');
    card.className = 'favorites-card';

    var body = document.createElement('div');
    body.className = 'favorites-card__body';

    var title = document.createElement('a');
    title.className = 'favorites-card__title';
    title.href = product.url || '#';
    title.textContent = product.title || 'Producto guardado';

    var price = document.createElement('p');
    price.className = 'favorites-card__price';
    price.textContent = product.price || '';

    var actions = document.createElement('div');
    actions.className = 'favorites-card__actions';

    var viewLink = document.createElement('a');
    viewLink.className = 'favorites-card__view';
    viewLink.href = product.url || '#';
    viewLink.textContent = 'Ver producto';

    var removeButton = document.createElement('button');
    removeButton.className = 'favorites-card__remove';
    removeButton.type = 'button';
    removeButton.textContent = 'Quitar';
    removeButton.dataset.favoriteRemove = product.id || product.handle || '';

    actions.appendChild(viewLink);
    actions.appendChild(removeButton);
    body.appendChild(title);

    if (product.price) {
      body.appendChild(price);
    }

    body.appendChild(actions);
    card.appendChild(createImage(product));
    card.appendChild(body);

    return card;
  }

  function renderFavorites() {
    var favorites = readFavorites().filter(function (product) {
      return product && (product.id || product.handle || product.title);
    });

    grid.innerHTML = '';
    emptyState.hidden = favorites.length > 0;
    grid.hidden = favorites.length === 0;

    favorites.forEach(function (product) {
      grid.appendChild(createCard(product));
    });
  }

  grid.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-favorite-remove]');

    if (!removeButton) {
      return;
    }

    var key = removeButton.dataset.favoriteRemove;
    var favorites = readFavorites().filter(function (product) {
      return String(product.id || product.handle || '') !== key;
    });

    if (writeFavorites(favorites)) {
      renderFavorites();
    }
  });

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      renderFavorites();
    }
  });

  window.addEventListener('dm:favorites:change', renderFavorites);
  renderFavorites();
})();
